/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// IMPORT CUSTOM COMPONENT
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
// import custom function
import { manuFactureHead } from './gridComponents/tableHead';
import {
  checkQuarterValidation,
  closeTab,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  filterSelectByList,
  tableGridHight350,
  radioGroupLabelNamePlan,
  rebateProgramLabelName,
  quarterLabelName,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  setErrorMessageForSearch,
  dispatchActiveInvoiceNumber,
  getManufacturerList,
  getRosiAllocatePaymentDetail,
  dispatchManufacturerData,
  getRebateProgramDropdownList,
  dispatchExistingInvoiceNumCheck,
  getQuarterData,
  getExistingInvoiceNumCount,
  getPlanTypeRadioBoxValue,
  setSearchPickInvoiceAssScreenTab,
  dispatchFailedAPIError,
  handleErrorMessageForAllocatePayment,
  clearReduxAllocatePaymentThirdScreen,
  dispatchAllocatePaymentHederData,
  setActiveDetailScreenTabs,
} from '../store/Actions';
import {
  dispatchNoPaySuspended,
  dispatchSaveDetailsResponse,
} from '../PQASTab/store/Actions';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { getAllocatePaymentScreenData } from './gridComponents/ROSIUtils';
import { flushSync } from 'react-dom';

const SearchPickInvAssociateWithCheckCom = React.memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function
  const fetchSearchScreenData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.pervSearchScreenData
  );
  const searchPickInvAssociateScreenObj = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.searchPickInvAssociateScreenObj
  );
  const errorMessagesFromRedux = useSelector(
    (state) =>
      state?.sharedState?.AllocatePaymentReducer
        ?.searchPickInvoiceAssScreenErrors
  );

  const invoiceNumberStatus = useSelector(
    (state) => state?.sharedState?.AllocatePaymentReducer?.invoiceNumCount
  );
  const activeInvoiceNumArray = useSelector(
    (state) => state?.sharedState?.AllocatePaymentReducer?.activeInvoiceNum
  );
  const UserDefaultValues = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const fetchManufacturerList = useSelector((state) =>
    state.sharedState.AllocatePaymentReducer?.manufacturerList?.sort(
      (a, b) => a.mfgId - b.mfgId
    )
  );
  const activeScreenDetails = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer.activeDetailScreenTabs
  );
  const getQuarterDataValue = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer.quarter
  );
  const AllocatePaymentReducer = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer
  );

  const updateDetailsAllData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.updateDetails
  );

  // Helper function to detect unsaved changes for a detail tab
  const hasUnsavedChangesFor = React.useCallback(
    (invoiceNum, checkNum, tabObj) => {
      if (!invoiceNum || !checkNum) return false;
      const detailKey = `${invoiceNum}-${checkNum}`;
      const detailState = updateDetailsAllData?.[detailKey];
      return tabObj?.isFormDirty || detailState?.flag === false;
    },
    [updateDetailsAllData]
  );

  // variable deceleration
  const gridRef = React.useRef();
  const initialFetchDoneRef = React.useRef(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridParams, setGridParams] = React.useState(null);
  const [planTypeOptions, setPlanTypeOptions] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState({});
  const [warningAlert, setWarningAlert] = React.useState(false);
  const [warningMessage, setWaringMessage] = React.useState('');
  const [modalTitle, setModalTitle] = React.useState('');
  const [alreadyExistInvoiceNum, setAlreadyExistInvoiceNum] =
    React.useState(false);
  const [values, setValues] = React.useState(
    searchPickInvAssociateScreenObj?.values
      ? searchPickInvAssociateScreenObj?.values
      : {
          selectedBy: UserDefaultValues?.defInvoiceSelectModeCd
            ? UserDefaultValues?.defInvoiceSelectModeCd
            : 'PQM',
          planTypeCd: UserDefaultValues?.planTypeCd
            ? UserDefaultValues?.planTypeCd
            : 'FD',
          rebateProgramCd: UserDefaultValues?.rebateProgramCd
            ? UserDefaultValues?.rebateProgramCd
            : '-1',
          quarterValue: null,
          invoiceNum: '',
        }
  );
  const [isNavigating, setIsNavigating] = React.useState(false);
  // handling onPage load call service
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(dispatchFailedAPIError(null));
    dispatch(getQuarterData());
  }, []);

  React.useEffect(() => {
    if (!initialFetchDoneRef.current && values?.quarterValue) {
      initialFetchDoneRef.current = true;
      handleFetchManufactureListData();
    }
  }, [values?.quarterValue]);
  // set Default first row selected on page load
  const handleDefaultRow = (index) => {
    if (fetchManufacturerList?.length > 0) {
      const rowIndex = index || 0;
      setSelectedRow(fetchManufacturerList[rowIndex]);
      dispatch(
        setSearchPickInvoiceAssScreenTab({
          ...searchPickInvAssociateScreenObj,
          currentIndex: rowIndex,
          selectedRow: fetchManufacturerList[rowIndex],
        })
      );
    }
  };
  const onFirstDataRendered = (params) => {
    const rowIndex = 0;
    if (params) {
      params.forEachNode(
        (node) => node.rowIndex === rowIndex && node.setSelected(true)
      );
    }
  };
  // set Initial state values
  React.useEffect(() => {
    if (
      searchPickInvAssociateScreenObj &&
      Object.keys(searchPickInvAssociateScreenObj)?.length === 0
    ) {
      dispatch(setErrorMessageForSearch([]));
    } else {
      const tempObj = searchPickInvAssociateScreenObj;
      if (tempObj?.fullScreenView) setFullScreenView(tempObj.fullScreenView);
      if (tempObj?.selectedRow) setSelectedRow(tempObj.selectedRow);
      if (tempObj.currentIndex) handleDefaultRow(tempObj.currentIndex);
    }
  }, [searchPickInvAssociateScreenObj]);
  // handing by default first row selection function
  const onGridReady = (params) => {
    handleClearFilter();
    setGridParams(params);
  };
  // click on filter icon after call
  const handleClearFilter = () => {
    if (gridRef !== null) {
      if (gridRef.current?.clearFilters) gridRef.current.clearFilters();
      if (gridParams?.columnApi && gridParams?.columnApi !== null) {
        gridParams.columnApi.applyColumnState({
          state: [{ colId: 'mfgId', sort: 'asc' }],
        });
      }
    }
  };
  // set play type Radio Data List for page load
  React.useEffect(() => {
    getPlanTypeRadioBoxValue().then((res) => {
      const planList =
        res?.length > 0 &&
        res?.map((obj) => {
          return {
            name:
              obj?.codeValueID?.codeValue === 'FD'
                ? 'Medicaid'
                : obj.shortDescription,
            value: obj.codeValueID.codeValue,
          };
        });
      setPlanTypeOptions(planList);
    });
  }, []);
  // set common dropdown list after calling API service
  React.useEffect(() => {
    getRebateProgramDropdownList(values?.planTypeCd).then((res) => {
      let list = [];
      if (
        res?.status === constantMessageData.STATUS_MSG &&
        res?.message === constantMessageData.SUCCESS_MSG
      ) {
        if (!_.isEmpty(res.data)) {
          list = _.map(res.data, (val) => ({
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
          }));
        }
      }
      setRebateProgramList(
        list.sort((key, val) =>
          key.name.toLowerCase().localeCompare(val.name.toLowerCase())
        )
      );
    });
  }, [values?.planTypeCd]);

  // set initial quarte Value
  React.useEffect(() => {
    if (Object.keys(searchPickInvAssociateScreenObj)?.length === 0) {
      if (
        getQuarterDataValue &&
        !searchPickInvAssociateScreenObj?.values?.quarterValue
      ) {
        setValues({
          ...values,
          quarterValue:
            getQuarterDataValue ??
            autoFormateDate(getQuarterDataValue?.toUpperCase()),
        });
        dispatch(
          setSearchPickInvoiceAssScreenTab({
            ...searchPickInvAssociateScreenObj,
            values: {
              ...values,
              quarterValue:
                getQuarterDataValue ??
                autoFormateDate(getQuarterDataValue?.toUpperCase()),
            },
          })
        );
      }
    }
  }, [getQuarterDataValue]);

  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux?.length > 0) {
      tabHighLigther('/pickInvoiceAssociateWithCheck', true);
    } else {
      tabHighLigther('/pickInvoiceAssociateWithCheck', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // check grid data come after 1st row selected.
  React.useEffect(() => {
    if (fetchManufacturerList && fetchManufacturerList?.length > 0) {
      handleDefaultRow(
        Object.keys(searchPickInvAssociateScreenObj)?.length === 0
          ? 0
          : searchPickInvAssociateScreenObj?.currentIndex
      );
    }
  }, [fetchManufacturerList]);
  // redirect allocate payment detail screen
  // check duplicate checkLog Number and different invoice Number
  // React.useEffect(() => {
  //   const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  //   if (
  //     updateTabs?.filter((x) => {
  //       return x.isAlreadyExistInvoiceNum;
  //     })?.length > 0
  //   ) {
  //     setModalTitle(
  //       `Pick an Invoice to Associate with this Check (${fetchSearchScreenData?.selectedRow?.checkLogNum})`
  //     );
  //     setAlreadyExistInvoiceNum(true);
  //     setWaringMessage(constantMessageData.ALREADY_EXIST_INVOICE_NUM_NAV);
  //   }
  // }, []);
  // const handleExistingTabNavigation = (existingTab, newInvoice, newCheck) => {
  //   const updateTabs = JSON.parse(localStorage.getItem('tabItemsData')) || [];
  //   const tabToUpdate = updateTabs.find((t) => t.navTo === existingTab.navTo);

  //   if (!tabToUpdate) return;

  //   // Set proper tab state flags that trigger standard close modal
  //   tabToUpdate.isDirty = true;
  //   tabToUpdate.needsConfirmation = true;
  //   tabToUpdate.pendingAction = {
  //     type: 'NAVIGATE',
  //     payload: {
  //       path: `/allocatePaymentDetail/${newCheck}-${newInvoice}`,
  //       title: `ROSI/PQAS [#${newInvoice}] Check Log #${newCheck}`,
  //     },
  //   };

  //   localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  //   redirectURLLink(existingTab.navTo, existingTab.tabId, history);
  // };
  React.useEffect(() => {
    setIsNavigating(false);
    // console.log('componentCalled');
  }, []);
  const handleRedirectURLtoDetailScreen = async (row) => {
    let localErr = errorMessagesFromRedux || [];
    const invoiceNumber =
      values?.selectedBy === 'IN' ? values.invoiceNum : selectedRow?.invoiceNum;
    const currentCheckLogNum = fetchSearchScreenData?.selectedRow?.checkLogNum;

    const isSameInvDiffCheck = activeScreenDetails?.find(
      (item) =>
        item.invoiceNumber === invoiceNumber &&
        item.checkNumber.toString() !== currentCheckLogNum.toString()
    );

    const isSameCheckDiffInv = activeScreenDetails?.find(
      (item) =>
        item.checkNumber === currentCheckLogNum &&
        item.invoiceNumber !== invoiceNumber
    );

    if (isSameCheckDiffInv) {
      setModalTitle(
        `Pick an Invoice to Associate with this Check (${currentCheckLogNum})`
      );
      setWarningAlert(true);
      setWaringMessage(
        `This check is already open with invoice ${isSameCheckDiffInv.invoiceNumber}`
      );
      redirectURLLink(
        `/allocatePaymentDetail/${isSameCheckDiffInv.checkNumber}-${isSameCheckDiffInv.invoiceNumber}`,
        `ROSI/PQAS [#${isSameCheckDiffInv.invoiceNumber} Chk Log #${isSameCheckDiffInv.checkNumber}]`,
        history
      );
      return;
    }

    if (isSameInvDiffCheck && !alreadyExistInvoiceNum) {
      setModalTitle(
        `Pick an Invoice to Associate with this Check  (${intialCheckNum})`
      );
      setAlreadyExistInvoiceNum(true);
      // setWarningAlert(true);
      setWaringMessage(constantMessageData.ALREADY_EXIST_INVOICE_NUM_NAV);

      window.existingTabToClose = {
        checkNumber: isSameInvDiffCheck.checkNumber,
        invoiceNumber: isSameInvDiffCheck.invoiceNumber,
        tabId: `ROSI/PQAS [#${isSameInvDiffCheck.invoiceNumber}] Check Log #${isSameInvDiffCheck.checkNumber}`,
        navTo: `/allocatePaymentDetail/${isSameInvDiffCheck.checkNumber}-${isSameInvDiffCheck.invoiceNumber}`,
        hasUnsavedChanges: hasUnsavedChangesFor(
          isSameInvDiffCheck.invoiceNumber,
          isSameInvDiffCheck.checkNumber,
          updateDetailsAllData?.[
            `${isSameInvDiffCheck.invoiceNumber}-${isSameInvDiffCheck.checkNumber}`
          ]
        ),
      };
      return;
    }

    // Case 3: Different invoice, different check (existing flow)
    const newObj = activeInvoiceNumArray || [];
    newObj.push({
      index: newObj.length,
      invoiceNum: invoiceNumber,
      checkLogNum: fetchSearchScreenData?.selectedRow?.checkLogNum,
      active: true,
    });
    dispatch(dispatchActiveInvoiceNumber(newObj));
    const searchScreenData = fetchSearchScreenData?.selectedRow;
    const resultData = await dispatch(
      getRosiAllocatePaymentDetail({
        invoiceNum: invoiceNumber,
        checkLogNum: intialCheckNum,
        checkPayeeCD:
          fetchSearchScreenData?.state?.allocateFrom === 'Check'
            ? searchScreenData?.checkPayeeCdVal
            : 'ALL',
        checkAmt: searchScreenData?.checkAmt
          ? parseFloat(searchScreenData.checkAmt?.toString().split('$')[1])
          : 0,
        mfgId: values?.selectedBy === 'IN' ? '' : row?.mfgId,
        planType: values?.selectedBy === 'IN' ? '' : values?.planTypeCd,
      })
    );
    const data = resultData?.headerAllocatePaymentData;
    const headerAllocatePaymentVO =
      resultData?.headerAllocatePaymentData?.headerAllocatePaymentVO;
    if (
      headerAllocatePaymentVO &&
      Object.keys(headerAllocatePaymentVO)?.length > 0
    ) {
      const obj = { ...AllocatePaymentReducer?.detailScreenErrors };
      obj[
        `${headerAllocatePaymentVO?.invoiceNum}-${headerAllocatePaymentVO.checkLogNum}`
      ] = [];
      dispatch(
        handleErrorMessageForAllocatePayment({
          detailScreenErrors: obj,
          searchScreenErrors: AllocatePaymentReducer?.searchScreenErrors
            ? AllocatePaymentReducer?.searchScreenErrors
            : [],
        })
      );

      getAllocatePaymentScreenData(
        data,
        dispatch,
        AllocatePaymentReducer,
        history,
        newObj
      );
    } else if (data?.forzenCase) {
      localErr = [];
      localErr.push({
        field: 'InvNumNotFrozen',
        errorType: 'invoiceNum',
        message: constantMessageData.INVOICE_NUMBER_NOT_FROZEN,
      });
      handleScrollToEvent();
    } else if (data?.noCheckPayeeForInvoice) {
      localErr = [];
      setWarningAlert(true);
      setModalTitle(
        `Pick an Invoice to Associate with this Check (${fetchSearchScreenData?.selectedRow?.checkLogNum})`
      );
      setWaringMessage(constantMessageData.CHECK_PAYEE_CODE_INV_NUMBER_MSG);
    } else if (
      data?.headerAllocatePaymentVO == null &&
      data?.checkPayeeMessage
    ) {
      setWarningAlert(true);
      setWaringMessage(data?.checkPayeeMessage);
      setModalTitle(
        `Pick an Invoice to Associate with this Check (${fetchSearchScreenData?.selectedRow?.checkLogNum})`
      );
    }
    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
  };
  // after call exIsting invoice number available on DB or not
  React.useEffect(() => {
    let localErr = errorMessagesFromRedux || [];
    if (parseInt(invoiceNumberStatus, [0, 1]) === 1) {
      dispatch(dispatchExistingInvoiceNumCheck(''));
      localErr = localErr.filter(
        (item) =>
          item.field !== 'noInvoiceNumExist' &&
          item.field !== 'resultNotFound' &&
          item.field !== 'resultNotFound1' &&
          item.field !== 'InvNumNotFrozen'
      );
      handleRedirectURLtoDetailScreen();
    } else if (parseInt(invoiceNumberStatus, [0, 1]) === 0) {
      dispatch(dispatchExistingInvoiceNumCheck(''));
      localErr = localErr.filter(
        (item) =>
          item.errorType !== 'invoiceNum' &&
          item.field !== 'resultNotFound' &&
          item.field !== 'resultNotFound1' &&
          item.field !== 'InvNumNotFrozen'
      );
      localErr.push({
        field: 'noInvoiceNumExist',
        errorType: 'invoiceNum',
        message: `${constantMessageData.NO_INVOICE_NUMBER_EXIST} (# ${values?.invoiceNum}) .`,
      });
      handleScrollToEvent();
    }
    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
  }, [invoiceNumberStatus]);
  // check validation function
  const validateRequest = () => {
    let localErr = errorMessagesFromRedux || [];
    let checkValidation = false;
    if (values.rebateProgramCd === null || values.rebateProgramCd === '-1') {
      checkValidation = true;
      localErr = localErr?.filter((item) => item.filed !== 'resultNotFound2');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    }
    if (values.quarterValue === '') {
      checkValidation = true;
      localErr = localErr.filter(
        (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
      );
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    } else if (!checkQuarterValidation(values.quarterValue)) {
      checkValidation = true;
      localErr = localErr.filter(
        (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
      );
      localErr.push({
        field: 'quarter',
        errorType: 'invalidFormat',
        message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
      });
    }

    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
    return !checkValidation;
  };
  // fetch Manufacture List onclick search button
  const handleFetchManufactureListData = async () => {
    handleClearFilter();
    let localErr = errorMessagesFromRedux || [];
    localErr = localErr?.filter((x) => x.errorType !== 'noRowSelected');
    dispatch(dispatchManufacturerData([]));
    if (values.rebateProgramCd === null || values.rebateProgramCd === '-1') {
      localErr = localErr?.filter((item) => item.filed !== 'resultNotFound2');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    }
    if (validateRequest()) {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'rebateProgramCd' &&
          item.filed !== 'quarter' &&
          item.filed !== 'resultNotFound2'
      );
      const resultData = await dispatch(
        getManufacturerList({
          checkLogNum: fetchSearchScreenData?.selectedRow?.checkLogNum,
          planType: values.planTypeCd,
          rebateProgramCD: values.rebateProgramCd,
          qtr: values.quarterValue,
        })
      );
      if (!(resultData?.manufacturerList?.length > 0)) {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'resultNotFound' &&
            item.field !== 'resultNotFound1' &&
            item.field !== 'InvNumNotFrozen'
        );
        localErr.push({
          field: 'resultNotFound',
          errorType: 'resultNotFound',
          message: constantMessageData.MNFC_NDC_ERROR_MSG,
        });
        handleScrollToEvent();
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'resultNotFound' &&
            item.field !== 'resultNotFound1' &&
            item.field !== 'InvNumNotFrozen'
        );
      }
    }
    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
  };
  // handle associate With check button onClick event after call
  const handleAssociateWithCheck = (row) => {
    let localErr = errorMessagesFromRedux || [];
    localErr = localErr?.filter((x) => x.errorType !== 'noRowSelected');
    if (values?.selectedBy === 'IN') {
      if (values?.invoiceNum === null || values?.invoiceNum === '') {
        localErr = [];
        localErr.push({
          field: 'resultNotFound1',
          errorType: 'invoiceNum',
          message: constantMessageData.EMPTY_INVOICE_NUMBER,
        });
      } else {
        localErr = localErr?.filter((x) => x.errorType !== 'invoiceNum');
        dispatch(dispatchExistingInvoiceNumCheck(''));
        dispatch(
          getExistingInvoiceNumCount({
            invoiceNum: values?.invoiceNum,
          })
        );
      }
    }
    if (values?.selectedBy === 'PQM') {
      if (validateRequest()) {
        if (
          Object.keys(selectedRow)?.length === 0 ||
          gridParams?.api?.getDisplayedRowCount() <= 0
        ) {
          localErr = localErr?.filter(
            (x) =>
              x.errorType === 'invoiceNum' ||
              x.filed === 'rebateProgramCd' ||
              x.filed === 'quarter'
          );
          localErr.push({
            field: 'resultNotFound2',
            errorType: 'noRowSelected',
            message: constantMessageData.NO_ROW_SELECTED_FOR_MANUFACTURER_GRID,
          });
          handleScrollToEvent();
        } else {
          localErr = localErr?.filter((x) => x.filed !== 'resultNotFound2');

          const invoiceToCheck = row?.invoiceNum || selectedRow?.invoiceNum;
          const currentCheckLogNum =
            fetchSearchScreenData?.selectedRow?.checkLogNum || intialCheckNum; // Check if this invoice is already open with a different check
          // console.log("invoiceToCheck",invoiceToCheck,"currentCheckLogNum",currentCheckLogNum)
          const isSameInvDiffCheck = activeScreenDetails?.find(
            (item) =>
              item.invoiceNumber.toString() === invoiceToCheck.toString() &&
              item.checkNumber.toString() !== currentCheckLogNum.toString()
          );
          // console.log("isSameInvDiffCheck")
          if (isSameInvDiffCheck && !alreadyExistInvoiceNum) {
            setModalTitle(
              `Pick an Invoice to Associate with this Check (${currentCheckLogNum})`
            );
            setAlreadyExistInvoiceNum(true);
            setWaringMessage(constantMessageData.ALREADY_EXIST_INVOICE_NUM_NAV);
            window.existingTabToClose = {
              checkNumber: isSameInvDiffCheck.checkNumber,
              invoiceNumber: isSameInvDiffCheck.invoiceNumber,
              tabId: `ROSI/PQAS [#${isSameInvDiffCheck.invoiceNumber}] Check Log #${isSameInvDiffCheck.checkNumber}`,
              navTo: `/allocatePaymentDetail/${isSameInvDiffCheck.checkNumber}-${isSameInvDiffCheck.invoiceNumber}`,
              hasUnsavedChanges: hasUnsavedChangesFor(
                isSameInvDiffCheck.invoiceNumber,
                isSameInvDiffCheck.checkNumber,
                updateDetailsAllData?.[
                  `${isSameInvDiffCheck.invoiceNumber}-${isSameInvDiffCheck.checkNumber}`
                ]
              ),
            };
            dispatch(
              setSearchPickInvoiceAssScreenTab({
                ...searchPickInvAssociateScreenObj,
                selectedRow: row || selectedRow,
                pendingNavigation: true,
                pendingNavigationRow: row,
              })
            );
            dispatch(setErrorMessageForSearch([...new Set(localErr)]));
            return;
          }
          handleRedirectURLtoDetailScreen(row);
        }
      }
    }
    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
  };

  // handing On change event on filed level
  const handleOnChangeEvent = (value, name) => {
    let localErr = errorMessagesFromRedux || [];
    if (name === 'planTypeCd') {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'rebateProgramCd' &&
          item.field !== 'resultNotFound' &&
          item.field !== 'resultNotFound1' &&
          item.field !== 'InvNumNotFrozen'
      );
      setValues({ ...values, [name]: value, rebateProgramCd: '-1' });
      dispatch(
        setSearchPickInvoiceAssScreenTab({
          ...searchPickInvAssociateScreenObj,
          values: { ...values, [name]: value, rebateProgramCd: '-1' },
        })
      );
    } else if (name === 'selectedBy') {
      setValues({ ...values, [name]: value });
      setSelectedRow({});
      dispatch(
        setSearchPickInvoiceAssScreenTab({
          ...searchPickInvAssociateScreenObj,
          currentIndex: 0,
          selectedRow: {},
          values: { ...values, [name]: value },
        })
      );
    } else {
      if (name === 'invoiceNum' && value !== '') {
        localErr = localErr.filter(
          (item) =>
            item.errorType !== 'invoiceNum' && item.field !== 'resultNotFound1'
        );
      }
      setValues({ ...values, [name]: value });
      dispatch(
        setSearchPickInvoiceAssScreenTab({
          ...searchPickInvAssociateScreenObj,
          values: { ...values, [name]: value },
        })
      );
    }
    if (name === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' &&
            item.field !== 'resultNotFound' &&
            item.field !== 'resultNotFound1' &&
            item.field !== 'InvNumNotFrozen'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' &&
            item.field !== 'resultNotFound' &&
            item.field !== 'resultNotFound1' &&
            item.field !== 'InvNumNotFrozen'
        );
      }
    }
    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
  };
  //  hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesFromRedux || [];
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' &&
            item.errorType !== 'invoiceNum' &&
            item.field !== 'resultNotFound2'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' &&
            item.errorType !== 'invoiceNum' &&
            item.field !== 'resultNotFound2'
        );
      }
    }
    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) =>
            item.field !== 'quarter' &&
            item.errorType !== 'invoiceNum' &&
            item.field !== 'resultNotFound2'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' &&
              item.errorType !== 'invoiceNum' &&
              item.field !== 'resultNotFound2'
          );
          setValues({
            ...values,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
          dispatch(
            setSearchPickInvoiceAssScreenTab({
              ...searchPickInvAssociateScreenObj,
              values: {
                ...values,
                quarterValue: autoFormateDate(value?.toUpperCase()),
              },
            })
          );
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' &&
              item.errorType !== 'invoiceNum' &&
              item.field !== 'resultNotFound2'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound2'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }
    if (type === 'invoiceNum') {
      if (values?.invoiceNum === null || values?.invoiceNum === '') {
        localErr = [];
        localErr.push({
          field: 'resultNotFound1',
          errorType: 'invoiceNum',
          message: constantMessageData.EMPTY_INVOICE_NUMBER,
        });
      } else {
        localErr = [];
      }
    }
    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
  };

  // click on full screen icon after call in Check grid
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(
      setSearchPickInvoiceAssScreenTab({
        ...searchPickInvAssociateScreenObj,
        fullScreenView: !fullScreenView,
      })
    );
  };
  const data = JSON.parse(localStorage.getItem('tabItemsData'));
  const checkObjFromTabData = data.find(
    (obj) => obj.navTo === '/pickInvoiceAssociateWithCheck'
  );
  let intialCheckNum = null;
  if (checkObjFromTabData) {
    const match = checkObjFromTabData.value.match(/\((\d+)\)/);
    intialCheckNum = match ? match[1] : '';
  }
  const isNumber = (evt) => {
    evt = evt || window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if ((charCode !== 8 && charCode !== 0 && charCode < 48) || charCode > 57) {
      evt.preventDefault();
      return false;
    }
    return true;
  };
  React.useEffect(() => {
    const syncActiveScreenDetailsWithLocalStorage = () => {
      const tabItemsData =
        JSON.parse(localStorage.getItem('tabItemsData')) || [];
      const activeTabURLs = tabItemsData
        .filter(
          (tab) => tab.navTo && tab.navTo.includes('/allocatePaymentDetail/')
        )
        .map((tab) => tab.navTo);
      // ('Active tab URLs from localStorage:', activeTabURLs);
      // console.log('Current activeScreenDetails:', activeScreenDetails);
      const activeTabPatterns = activeTabURLs
        .map((url) => {
          const match = url.match(/\/allocatePaymentDetail\/(.+)/);
          if (match) {
            const [checkNum, invoiceNum] = match[1].split('-');
            return { checkNum, invoiceNum, url };
          }
          return null;
        })
        .filter(Boolean);
      // console.log('Active tab patterns:', activeTabPatterns);
      const syncedActiveScreenDetails = activeScreenDetails.filter(
        (activeTab) => {
          return activeTabPatterns.some(
            (pattern) =>
              pattern.checkNum === activeTab.checkNumber &&
              pattern.invoiceNum === activeTab.invoiceNumber
          );
        }
      );
      if (syncedActiveScreenDetails.length !== activeScreenDetails.length) {
        // console.log("Syncing activeScreenDetails with localStorage:");
        // console.log("Before sync:", activeScreenDetails);
        // console.log("After sync:", syncedActiveScreenDetails);
        dispatch(setActiveDetailScreenTabs(syncedActiveScreenDetails));
      }
    };
    syncActiveScreenDetailsWithLocalStorage();
  }, [
    JSON.stringify(localStorage.getItem('tabItemsData')),
    activeScreenDetails.length,
  ]);
  // Add this helper function for handling navigation with unsaved changes check
  const handleNavigationWithUnsavedCheck = (
    existingTab,
    destinationPath,
    destinationTitle
  ) => {
    // console.log('[Navigation Check] Start', {
    //   existingTab,
    //   isNavigating,
    //   destinationPath,
    // });

    if (!existingTab || isNavigating) {
      // console.log('[Navigation Check] Blocked - Already navigating or no tab', {
      //   isNavigating,
      // });
      return false;
    }

    const tabs = JSON.parse(localStorage.getItem('tabItemsData')) || [];
    const tabToUpdate = tabs.find((tab) => tab.navTo === existingTab.navTo);

    // console.log('[Navigation Check] Found tab to update:', tabToUpdate);

    if (!tabToUpdate) return false;

    // Check if tab has unsaved changes
    const hasUnsavedChanges = hasUnsavedChangesFor(
      existingTab.invoiceNumber,
      existingTab.checkNumber,
      tabToUpdate
    );

    // console.log('[Navigation Check] Unsaved changes check:', {
    //   hasUnsavedChanges,
    //   invoiceNum: existingTab.invoiceNumber,
    //   checkNum: existingTab.checkNumber,
    // });

    if (hasUnsavedChanges) {
      // console.log('[Navigation Check] Setting navigation flag');
      setIsNavigating(true);

      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData')) || [];

      // console.log('[Navigation Check] Current tabs before update:', updateTabs);

      // Show save modal on existing tab
      updateTabs.forEach((tab) => {
        if (tab.navTo === existingTab.navTo) {
          // console.log('[Navigation Check] Updating specific tab:', tab.navTo);
          tab.isSave = true;
          tab.redirectURLObj = {
            checkLogNum: fetchSearchScreenData?.selectedRow?.checkLogNum,
            invoiceNum:
              values?.selectedBy === 'IN'
                ? values.invoiceNum
                : selectedRow?.invoiceNum,
          };
        }
        tab.isAlreadyExistInvoiceNum = false;
        tab.showConfirmClose = true;
        tab.isClosing = true;
        tab.nextRoute = destinationPath;
        tab.nextTabTitle = destinationTitle;
        tab.isDirty = true;
      });

      // console.log('[Navigation Check] Updated tabs:', updateTabs);

      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

      if (!isNavigating) {
        // console.log(
        //   '[Navigation Check] Triggering navigation to:',
        //   existingTab.navTo
        // );
        redirectURLLink(existingTab.navTo, existingTab.tabId, history);
        window.existingTabToClose = null;
      }

      return true;
    }

    // console.log('[Navigation Check] No unsaved changes, allowing normal flow');
    return false;
  };

  const handleModalOk = async () => {
    setAlreadyExistInvoiceNum(false);

    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData')) || [];
    const existingTab = window.existingTabToClose;

    // Prepare destination info
    const newInvoice =
      values?.selectedBy === 'IN' ? values.invoiceNum : selectedRow?.invoiceNum;
    const newCheck = fetchSearchScreenData?.selectedRow?.checkLogNum;
    const destinationPath = `/allocatePaymentDetail/${newCheck}-${newInvoice}`;
    const destinationTitle = `ROSI/PQAS [#${newInvoice}] Check Log #${newCheck}`;

    // Check for unsaved changes
    const hasUnsavedChanges =
      existingTab &&
      hasUnsavedChangesFor(
        existingTab.invoiceNumber,
        existingTab.checkNumber,
        updateTabs.find((tab) => tab.navTo === existingTab.navTo)
      );

    if (existingTab && hasUnsavedChanges) {
      // Mark tab for save and navigation
      updateTabs.forEach((tab) => {
        if (tab.navTo === existingTab.navTo) {
          tab.isSave = true;
          tab.showConfirmClose = true;
          tab.isClosing = true;
          tab.redirectURLObj = {
            checkLogNum: newCheck,
            invoiceNum: newInvoice,
            perviousNavTo: true,
          };
          tab.nextRoute = destinationPath;
          tab.nextTabTitle = destinationTitle;
        }
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      // Navigate to tab to trigger save
      redirectURLLink(existingTab.navTo, existingTab.tabId, history);
      return;
    }

    // No unsaved changes: close current tab and open new tab
    updateTabs.forEach((t) => (t.isAlreadyExistInvoiceNum = false));
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    if (existingTab) {
      closeTab(existingTab.navTo, history);
      dispatch(
        clearReduxAllocatePaymentThirdScreen(
          existingTab.invoiceNumber,
          existingTab.checkNumber,
          history
        )
      );
      if (
        AllocatePaymentReducer?.headerAllocatePaymentData?.[
          `${existingTab.invoiceNumber}-${existingTab.checkNumber}`
        ]
      ) {
        dispatch(
          dispatchAllocatePaymentHederData(
            {
              ...AllocatePaymentReducer.headerAllocatePaymentData[
                `${existingTab.invoiceNumber}-${existingTab.checkNumber}`
              ],
              closeTab: true,
            },
            existingTab.invoiceNumber,
            existingTab.checkNumber
          )
        );
      }
      window.existingTabToClose = null;
    } // Open new tab - handle both IN and PQM modes
    if (values?.selectedBy === 'PQM') {
      const rowToNavigate =
        searchPickInvAssociateScreenObj?.pendingNavigationRow ||
        searchPickInvAssociateScreenObj?.selectedRow ||
        selectedRow;
      handleRedirectURLtoDetailScreen(rowToNavigate);
      dispatch(
        setSearchPickInvoiceAssScreenTab({
          ...searchPickInvAssociateScreenObj,
          pendingNavigation: false,
          pendingNavigationRow: null,
        })
      );
    } else {
      handleRedirectURLtoDetailScreen();
    }
  };

  return (
    <div
      className="tBillPanel custom-check tabs-container"
      data-testid="CheckLetter-component"
    >
      <CustomSeparator
        parent1="Tasks"
        parent2={`Pick an Invoice to Associate with this Check (${intialCheckNum})`}
      />
      {!fullScreenView && (
        <>
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesFromRedux?.filter((x) => {
                  if (values?.selectedBy === 'IN') {
                    return x.errorType === 'invoiceNum';
                  }
                  return x.errorType !== 'invoiceNum';
                })?.length > 0
                  ? _.map(
                      errorMessagesFromRedux?.filter((x) => {
                        if (values?.selectedBy === 'IN') {
                          return x.errorType === 'invoiceNum';
                        }
                        return x.errorType !== 'invoiceNum';
                      }),
                      (l) => l.message
                    )
                  : []
              ),
            ]}
          />
        </>
      )}
      <Spinner load={spinnerLoader} />
      <div className="no-margin">
        {!fullScreenView && (
          <div className="row mb-2">
            <div
              className={`col-12 col-sm-12 ${
                values?.selectedBy === 'PQM'
                  ? 'col-md-7 col-lg-7'
                  : 'col-md-8 col-lg-8'
              }`}
            >
              <RadioGroupComponent
                data-testid="action-redio-btn"
                id="action-radio-btn-action"
                labelName="Select By"
                required
                reqColor
                optionList={filterSelectByList}
                defaultValue={values?.selectedBy}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'selectedBy');
                  setSelectedRow({});
                  dispatch(dispatchFailedAPIError(null));
                  handleClearFilter();
                  if (
                    e === 'IN' &&
                    errorMessagesFromRedux?.filter(
                      (x) => x.errorType === 'invoiceNum'
                    )?.length > 0
                  ) {
                    tabHighLigther('/pickInvoiceAssociateWithCheck', true);
                  } else if (
                    e === 'PQM' &&
                    errorMessagesFromRedux?.filter(
                      (x) => x.errorType !== 'invoiceNum'
                    )?.length > 0
                  ) {
                    tabHighLigther('/pickInvoiceAssociateWithCheck', true);
                  } else {
                    tabHighLigther('/pickInvoiceAssociateWithCheck', false);
                  }
                }}
                className="log-batch-filter-radio"
              />
            </div>
            <div
              className={`col-12 col-sm-12  ${
                values?.selectedBy === 'PQM'
                  ? 'col-md-5 col-lg-5'
                  : 'col-md-4 col-lg-4 mt-2'
              }  frr-radio-40per-width`}
            >
              {values?.selectedBy === 'PQM' && (
                <RadioGroupComponent
                  data-testid="filter-plan-by-radio-btn-plan"
                  id="filter-plan-by-radio-btn-action"
                  labelName={radioGroupLabelNamePlan}
                  required
                  reqColor
                  optionList={planTypeOptions}
                  defaultValue={values && values.planTypeCd}
                  filterAction={(e) => {
                    handleOnChangeEvent(e, 'planTypeCd');
                  }}
                  className="log-batch-filter-radio"
                />
              )}
              {values?.selectedBy === 'IN' && (
                <fieldset className="custom-fieldset">
                  <legend aria-hidden="true" className="d-none" />
                  <div className="row">
                    <div className="col-12">
                      <div className="mui-custom-form with-select">
                        <TextField
                          label="Invoice Number"
                          data-testid="invoice-number"
                          autoComplete="off"
                          id="invoice-number"
                          required
                          fullWidth
                          select={false}
                          onKeyPress={isNumber}
                          inputProps={{ maxLength: 38, id: 'invoice-number' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={values?.invoiceNum}
                          onChange={(e) => {
                            if (e?.target?.value?.length < 39) {
                              handleOnChangeEvent(e.target.value, 'invoiceNum');
                            }
                          }}
                          onBlur={(e) =>
                            handleOnblurEvent('invoiceNum', e.target.value)
                          }
                          className={
                            errorMessagesFromRedux?.length > 0
                              ? _.map(errorMessagesFromRedux, (l) =>
                                  l.errorType === 'invoiceNum'
                                    ? 'mandate-fields'
                                    : null
                                )
                              : null
                          }
                          helperText={[
                            ...new Set(
                              errorMessagesFromRedux?.length > 0
                                ? _.map(errorMessagesFromRedux, (l) =>
                                    l.errorType === 'invoiceNum'
                                      ? l.message
                                      : null
                                  )
                                : null
                            ),
                          ]}
                          error={[
                            ...new Set(
                              errorMessagesFromRedux?.length > 0
                                ? _.map(errorMessagesFromRedux, (l) =>
                                    l.errorType === 'invoiceNum'
                                      ? l.message
                                      : null
                                  )
                                : null
                            ),
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
              )}
            </div>
          </div>
        )}
        {!fullScreenView && values?.selectedBy === 'PQM' && (
          <div className="row mb-2">
            <div className="col-12">
              <fieldset className="custom-fieldset">
                <legend aria-hidden="true" className="d-none" />
                <div className="form-wrapper my-2">
                  <div className="mui-custom-form with-select">
                    <TextField
                      data-testid="rebate_program-generate-inv"
                      id="rebate_program"
                      label={rebateProgramLabelName}
                      fullWidth
                      select
                      required
                      placeholder=""
                      inputProps={{ maxLength: 11, id: 'rebate_program' }}
                      onBlur={(e) =>
                        handleOnblurEvent('rebateProgramCd', e.target.value)
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values && values.rebateProgramCd}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                      }
                      className={[
                        ...new Set(
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'rebateProgramCd'
                                  ? 'mandate-fields'
                                  : null
                              )
                            : null
                        ),
                      ]}
                      helperText={[
                        ...new Set(
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'rebateProgramCd' ? l.message : null
                              )
                            : null
                        ),
                      ]}
                      error={[
                        ...new Set(
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'rebateProgramCd' ? l.message : null
                              )
                            : null
                        ),
                      ]}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />

                      {rebateProgramList &&
                        rebateProgramList?.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                    </TextField>
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      data-testid="check_quarter_gi"
                      id="check_by_invoice_quater"
                      required
                      label={quarterLabelName}
                      fullWidth
                      autoComplete="off"
                      placeholder=""
                      inputProps={{ maxLength: 6 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values && values.quarterValue}
                      onChange={(e) => {
                        handleOnChangeEvent(e.target.value, 'quarterValue');
                      }}
                      onBlur={(e) =>
                        handleOnblurEvent('quarter', e.target.value)
                      }
                      className={[
                        ...new Set(
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'quarter' ? 'mandate-fields' : null
                              )
                            : null
                        ),
                      ]}
                      helperText={[
                        ...new Set(
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'quarter' ? l.message : null
                              )
                            : null
                        ),
                      ]}
                      error={[
                        ...new Set(
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'quarter' ? l.message : null
                              )
                            : null
                        ),
                      ]}
                    />
                  </div>
                  <div className="mui-custom-form input-md ">
                    <Button
                      className="btn btn-success btn-search mt-20"
                      style={{ marginTop: '20px' }}
                      onClick={() => handleFetchManufactureListData()}
                      data-testid="check_search_cbi"
                    >
                      <SVGComponent iconName="Icon-search" /> {'  '}
                      Search
                    </Button>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-sm-12">
            {!fullScreenView && (
              <div className="text-right mt-2">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="resume-btn"
                  type="button"
                  onClick={() => {
                    handleAssociateWithCheck(selectedRow);
                    dispatch(
                      handleErrorMessageForAllocatePayment({
                        detailScreenErrors: {},
                        searchScreenErrors:
                          errorMessagesFromRedux?.searchScreenErrors
                            ? errorMessagesFromRedux?.searchScreenErrors
                            : [],
                      })
                    );
                    dispatch(dispatchSaveDetailsResponse({}));
                    dispatch(dispatchNoPaySuspended({}));
                  }}
                >
                  {'  '} Associate With Check
                </Button>
              </div>
            )}
            {values?.selectedBy === 'PQM' && (
              <TableGridWithFeatures
                ref={gridRef}
                gridCall={onGridReady}
                gridDataRendered={onFirstDataRendered}
                data-testid="manufacturer-cbi-table"
                rowSelection="single"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridHeight={fullScreenView ? '70vh' : tableGridHight350}
                rowData={fetchManufacturerList}
                columnDefs={manuFactureHead}
                onSelect={(e) => {
                  setSelectedRow(e?.data);
                }}
                cellClickedListener={(e) => {
                  handleAssociateWithCheck(e?.data);
                  dispatch(dispatchNoPaySuspended({}));
                  dispatch(dispatchSaveDetailsResponse({}));
                  dispatch(
                    handleErrorMessageForAllocatePayment({
                      detailScreenErrors: {},
                      searchScreenErrors:
                        errorMessagesFromRedux?.searchScreenErrors
                          ? errorMessagesFromRedux?.searchScreenErrors
                          : [],
                    })
                  );
                  setSelectedRow(e?.data);
                }}
                onFilterData={(data, val) => {
                  if (val === 'clearFilter') {
                    let localErr = errorMessagesFromRedux || [];
                    localErr = localErr.filter(
                      (x) => x.errorType !== 'noRowSelected'
                    );
                    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
                  }
                }}
                exportFile
                animateRows
                sideBar={false}
                helpMessage="* On Double Click of Results, system should navigate to Detail page"
                fileName="AP-Manufacturer Grid"
                singleClickEdit
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                frameworkComponents={{
                  RenderMFGName: (cellInfo) => {
                    const name = cellInfo?.data?.mfgName;
                    if (name && name.length > 56) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
              />
            )}
          </div>
        </div>
      </div>
      <CommonModal
        className="dialog-420"
        data-testid="commonModal1"
        open={warningAlert}
        viewAction
        viewHeader
        onOk={() => {
          setWarningAlert(false);
          redirectURLLink('/allocatePayment', 'Allocate Payments', history);
        }}
        onClose={() => {
          setWarningAlert(false);
        }}
        okTitle="Ok"
        modalTitle={modalTitle}
        childrenComponent={<div className="p-3">{warningMessage}</div>}
      />
      <CommonModal
        className="dialog-420"
        data-testid="commonModal2"
        open={alreadyExistInvoiceNum}
        viewAction
        viewHeader
        onOk={handleModalOk}
        onClose={() => {
          setAlreadyExistInvoiceNum(false);
          const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
          updateTabs.forEach((item) => (item.isAlreadyExistInvoiceNum = false));
          localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
          const objItem = activeInvoiceNumArray || [];
          objItem.splice(objItem?.length - 1, 1);
          dispatch(dispatchActiveInvoiceNumber(objItem));
        }}
        okTitle="Yes"
        closeTitle="No"
        modalTitle={modalTitle}
        childrenComponent={<div className="p-3">{warningMessage}</div>}
      />
    </div>
  );
});
export default SearchPickInvAssociateWithCheckCom;
